export enum DocumentDisplayName {
  PolicyApplication = "Policy Application",
  PolicyApplicationSigned = "Policy Application_Signed",
  PolicyDocument = "Policy Document",
  EndorsementPolicyDocument = "Endorsement Policy Document",
  RenewalPolicyDocument = "Renewal Policy Document",
  AdverseActionClue = "Adverse Action Clue",
  AdverseActionInsurance = "Adverse Action Insurance",
  CancellationNotice = "Notice of Cancellation",

  QuoteProposalDocument = "Quote Proposal Document",
  SequoiaProposalPacket = "Proposal Packet",

  InvoiceDocument = "Invoice Document",
  ValuationReport = "Valuation Report",

  InspectionOrderingDocument = "InspectionOrderingDocument",
}

export const DOCUMENTS_TO_HIDE = [
  DocumentDisplayName.InvoiceDocument,
  DocumentDisplayName.QuoteProposalDocument,
  DocumentDisplayName.SequoiaProposalPacket,
];

export const ALL_POLICY_DOCUMENTS_NAMES =
  Object.values<DocumentDisplayName>(DocumentDisplayName);
